import moment from "moment-timezone"
import { FEATURE_CINECLUB_DATE, FEATURE_PARTNERS, metadata } from "lacinetek-common/src/metadata"

import { useCart } from "lib/cart"
import { useTranslation } from "lib/i18n/translation"
import { FETCH_CATEGORY_VIDEO_PLAYER } from "lib/graphql"

import { Query } from "components/common"
import Image from "components/common/image"
import { presentedSplitter } from "./intro"

export const partnerUrl = (partner) => {
	return partner.includes("[") ? partner.split("[")[0] : ""
}

export const partnerImage = (partner) => {
	return partner.includes("[") ? partner.split("[")[1].replace("]", "") : partner
}

export const Description = ({ club, film, loading }) => {
	if (loading) {
		return <section className="cine-club splitted" />
	}

	const { c } = useTranslation("common")
	const { addToCart } = useCart()
	const productIsAvailableSomewhere = Object
		.keys(film.countriesAvailability)
		.map(key => film.countriesAvailability[key])
		.filter(o => !!o).length > 0

	return (
		<section className="cine-club splitted">
			<aside>
				<div className="videoplayer youtube">
					<Query
						query={FETCH_CATEGORY_VIDEO_PLAYER}
						options={{ variables: { id: club.id } }}
						renderLoading={() => <div className="is-loading" />}
					>
						{({ cms: { categories: { items: [{ videos: { items: videos } }] } } }) => {
							if (videos.length == 0) return null

							const [{ player }] = videos

							return player ? <iframe src={player.url} /> : null
						}}
					</Query>
				</div>
			</aside>
			<div className="content">
				<h2 className="title">{film.name}</h2>
				<span className="director">{c("of")} {film.director}</span>
				<div className="description" dangerouslySetInnerHTML={{ __html: club.description }} />
				<div className="excerpt">
					<p>{c("presented-by")} {presentedSplitter(club.descriptionShort, c)}</p>
					{
						metadata(club, FEATURE_CINECLUB_DATE)
						&& moment(metadata(club, FEATURE_CINECLUB_DATE), "DD/MM/YYYY HH:mm").isValid()
						&& <p>
							{c("broadcast-on")} <strong>{moment(metadata(club, FEATURE_CINECLUB_DATE), "DD/MM/YYYY hh:mm").format(`DD MMMM YYYY [${c("at")}] HH[h]mm`)}</strong>
						</p>
					}
				</div>
				{metadata(club, FEATURE_PARTNERS) && (
					<div className="in-collaboration">
						<p>{c("in-partnership-with")}</p>
						{metadata(club, FEATURE_PARTNERS).split(';').map((partner, index) => (
							<a
								key={`partner-link-${index}`}
								href={partnerUrl(partner)}
								target="_blank"
								aria-label={`${c("to-external-site")} ${partnerUrl(partner)}`}
								rel="nofollow noopener"
							>
								<span className="hidden">{c("external-link")}</span>
								<figure key={index}>
									<picture>
										<Image src={partnerImage(partner)} alt={partnerUrl(partner)} />
									</picture>
								</figure>
							</a>
						))}
					</div>
				)}
				<nav className="buttons small">
					<a
						href="#"
						onClick={e => { e.preventDefault(); addToCart(film, { gift: true }) }}
						rel="nofollow noopener"
						title={c("offer-the-session")}
						data-overlay="#overlay-add-film-to-cart-gift"
						className={`icon-gift ${productIsAvailableSomewhere ? "" : "disabled"}`}
					>
						{c("offer-the-session")}
					</a>
				</nav>
			</div>
		</section>
	)
}
